import { Component, EventEmitter, Output } from '@angular/core';
import { generateId } from '../../helper/id-generator.helper';

/**
 * Agreement component displays agreement text with label.
 */
@Component({
    selector: 'ssf-agreement',
    template: require('./agreement.component.html'),
    styles: [require('./agreement.component.scss')]
})
export class AgreementComponent {

    agreed = false;
    @Output() onAgreed = new EventEmitter<boolean>();

    public labelId: string;

    constructor() {
        this.labelId = generateId();
    }

    onChange() {
        this.onAgreed.emit(this.agreed);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/agreement/agreement.component.ts